import { IconContainer, IconSize } from "nvs-design-system/dist/IconContainer";
import { PlaceholderAchievement } from "nvs-ds-icons/react/nvs";

export const achievementPlaceholderTestId = "achievementPlaceholder";
const numOfPlaceholderAchivements = 3;

const PlaceholderAchievements = () => (
  <div
    className="flex flex-wrap gap-4"
    data-testid={achievementPlaceholderTestId}
  >
    {Array.from(Array(numOfPlaceholderAchivements)).map((_, i) => (
      <IconContainer key={i} size={IconSize.lg}>
        <PlaceholderAchievement />
      </IconContainer>
    ))}
  </div>
);

export default PlaceholderAchievements;
